// StarRating.js

import React from "react";

const StarRating = ({ onChange, rating }) => {
    const handleRating = (index) => {
      onChange(index + 1);
    };
  
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        {[...Array(5)].map((_, index) => (
          <svg
            key={index}
            onClick={() => handleRating(index)}
            xmlns="http://www.w3.org/2000/svg"
            fill={index < rating ? "yellow" : "none"}
            viewBox="0 0 24 24"
            stroke="currentColor"
            style={{ width: '30px', height: '30px', cursor: 'pointer' }}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 2l3.09 6.26 6.91 1-5 4.87 1.18 6.87L12 17.77 6.82 21l1.18-6.87-5-4.87 6.91-1L12 2z"
            />
          </svg>
        ))}
      </div>
    );
  };
  

export default StarRating;
